export interface AlarmRouteParams {
  tenantId: string;
  siteId: string;
  cameraKey: string;
}

export function buildAlarmRoutePaths({ tenantId, siteId, cameraKey }: AlarmRouteParams) {
  const base = `/tenants/${tenantId}/sites/${siteId}/cameras/${cameraKey}/alarms`;
  return {
    routine: `${base}/routine`,
    response: `${base}/response`,
    timezone: `${base}/timezone`,
    appliedSchedule: `${base}/applied-schedule`,
    addException: `${base}/exceptions/create`,
    exception: (exceptionId: string) => `${base}/exceptions/${exceptionId}`,
  };
}
